// fix vh on mobile when top line
export const vhCorrector = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");
};
